import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@cvent/carina/components/Menu';
import Button from '@cvent/carina/components/legacy/Button/Button';
import useTheme from '@cvent/blocks/hooks/useTheme';
import { useTranslate } from 'nucleus-text';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { useAnalytics } from '@hooks/useAnalytics';
import { getCultureCode, setLocaleCookie } from '../../../locales';

const useStyles = () => {
  const { font } = useTheme();
  return {
    dropDown: {
      margin: 'auto',
      width: '180px'
    },
    dropdownFooter: {
      backgroundColor: 'transparent',
      fontWeight: font.base.weight.regular,
      fontSize: '0.875rem',
      fontFamily: font.base.family,
      width: '190px',
      textOverflow: 'ellipsis'
    },
    dropdownFooterNew: {
      backgroundColor: 'transparent',
      fontWeight: font.base.weight.regular,
      fontSize: '0.875rem',
      fontFamily: font.base.family,
      paddingLeft: '0px',
      paddingRight: '0px',
      textDecoration: 'underline',
      color: font.color.base
    }
  };
};
// Language selector will allow attendee to change the language manually,
// visible when attendeeHubMultilingual feature turned on and the event is multi-lingual
// hidden if the feature is turned off or the event is in single langauge.
const LanguageSelector = ({ eventLocaleInfo, setLocale, locale, eventId }) => {
  const styles = useStyles();
  const analytics = useAnalytics();
  const { translate: t } = useTranslate();

  const eventLocaleList = eventLocaleInfo?.map(localeInfo => {
    return {
      label: () => (
        <div
          {...injectTestId(
            `language-selector-footer-menu-${localeInfo?.cultureCode}`
          )}
        >
          {t('LocaleSelector-Dropdown-Option-Web', {
            languageName: localeInfo?.languageName,
            cultureCode: getCultureCode(localeInfo)
          })}
        </div>
      ),
      value: localeInfo?.cultureCode
    };
  });
  const findLocale = eventLocaleInfo?.find(x => x.cultureCode === locale);
  const label = t('LocaleSelector-Dropdown-Option-Web', {
    languageName: findLocale?.languageName,
    cultureCode: getCultureCode(findLocale)
  });
  const selectorTestId = 'language-selector-footer';
  const onLanguageSelect = option => {
    const defaultLocale = eventLocaleInfo.find(
      eventLocaleItem => eventLocaleItem.isDefault
    );
    const selectedLocale = option.value;
    const isDefaultLocale = !!(defaultLocale.cultureCode === selectedLocale);
    setLocaleCookie(eventId, setLocale, selectedLocale, isDefaultLocale);
    analytics.track({
      id: 'footer_language_selection',
      selectedLocale
    });
  };

  return (
    <div>
      {eventLocaleList?.length > 1 && (
        <Menu
          maxHeight="250px"
          testID="language-selector-footer-menu"
          options={eventLocaleList}
          onSelect={option => onLanguageSelect(option)}
          trigger={handlePress => (
            <Button
              onClick={handlePress}
              testID={selectorTestId}
              accessibilityLabel={t(
                'LanguageManagement-Web-Dropdown-Accessibility'
              )}
              style={styles.dropdownFooterNew}
            >
              {label}
            </Button>
          )}
          selected={locale}
        />
      )}
    </div>
  );
};

LanguageSelector.propTypes = {
  eventLocaleInfo: PropTypes.array,
  setLocale: PropTypes.func,
  locale: PropTypes.string,
  eventId: PropTypes.string
};

export default LanguageSelector;
